import { LaunchDarklyService, DateUtilsService, BookValueSpreadProviderName, BookProviderService} from 'remarketing-angular-library';
import { DetailsQueries } from './../../queries/details.queries';
import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { get } from 'lodash';
import { AuctionOpenPrice } from './../../interfaces/auction-detail';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SharedlistsService } from '../../../../../shared/services/sharedlists/sharedlists.service';
import { CurrencyFormatService, BadgeStatusPipe, SaComponent } from 'smartauction-frontend-micro-library';
import { RouterLink } from '@angular/router';
import { TooltipComponent, AuctionBadgeComponent, DatalistItemComponent } from 'remarketing-ui-components-lib';
import { AsyncPipe, DecimalPipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { VehicleDetailsQuery } from '../../interfaces/vehicle-details.query';

@Component({
    selector: 'lib-auction-detail',
    templateUrl: './auction-detail.component.html',
    styleUrls: ['./auction-detail.component.scss'],
    imports: [TranslocoDirective, TooltipComponent, AuctionBadgeComponent, DatalistItemComponent, RouterLink, AsyncPipe, DecimalPipe, BadgeStatusPipe]
})
export class AuctionDetailComponent extends SaComponent implements OnInit {
  @Select(DetailsQueries.auctionItem) auctionItem$: Observable<any>;
  @Select(DetailsQueries.bookValues) bookValues$: Observable<AuctionOpenPrice>;
  @Select(DetailsQueries.postDate) posteDate$: Observable<string>;
  @Select(DetailsQueries.defaultSpreadToBook) defaultSpreadToBook$: Observable<string>;
  @Select(DetailsQueries.vehicleDetails) details$: Observable<VehicleDetailsQuery>;

  showAuctionStartTime = false;
  showAuctionEndTime = false;
  showAuctionExtendTime = false;
  spreadToBookMetaTitle: string;
  spreadToBookTitle: string;
  spreadToBookBody: string;

  auctionItem: any;

  isMobile = false;

  spreadToBook: number;

  tenantName: string;

  currentListType = '';
  offerListTooltipTitle = '';
  offerListTooltipBody = '';

  translations = {
    partOf: '',
    sharedList: '',
    customOffer: '',
    sharedListTooltipTitle: '',
    customOfferTooltipTitle: ''
  };

  constructor(
    private readonly store: Store,
    private readonly bookProviderService: BookProviderService,
    private readonly _launchDarklyService: LaunchDarklyService,
    private readonly translocoService: TranslocoService,
    private readonly _sharedListsService: SharedlistsService,
    private readonly dateUtilService: DateUtilsService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {
    super();
  }

  ngOnInit() {
    this.getTranslations();
    this.tenantName = this.getTenantNameFromStore();
    this.auctionItem$.subscribe(auctionItem => {
      if (auctionItem) {
        this.auctionItem = auctionItem;

        !auctionItem.auctionWindow
          ? (this.showAuctionStartTime = true)
          : auctionItem.auctionWindow === 'INPROGRESS'
            ? (this.showAuctionEndTime = true)
            : auctionItem.auctionWindow === 'EXTENDED'
              ? (this.showAuctionExtendTime = true)
              : (this.showAuctionStartTime = true);
      }
    });
    this.getOfferListTooltipTranslations();
  }

  getShareListVehicles() {
    return this._sharedListsService.getShareListVehicles();
  }

  get offerListsTooltip() {
    return this._sharedListsService.offerListsTooltip(this.offerListTooltipTitle, this.offerListTooltipBody);
  }

  get isOfferListsTooltipBodyEmpty() {
    return this._sharedListsService.isOfferListsTooltipBodyEmpty(this.offerListTooltipBody);
  }

  get isLegacyVDPLinkEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('vdp-legacyVDPLinkEnabled', false);
  }

  get isTenantBadgeEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('sell-tenantBadgeEnabled', false);
  }

  get(path: string, otherwise: any = 'N/A'): string {
    return get(this.auctionItem, path, otherwise);
  }

  get msrp() {
    return get(this.auctionItem, 'msrp');
  }

  get spreadToBookTooltip() {
    return {
      metaTitle: this.spreadToBookMetaTitle,
      title: this.spreadToBookTitle,
      body: `${this.spreadToBookBody} ${this.bookProviderService.defaultBookProviderName} ${this.bookProviderService.defaultBookProviderValue}.`
    };
  }

  get spreadToBookValue() {
    if (this.spreadToBook) {
      return this.spreadToBook;
    }

    const defaultBookProvider = this.store.selectSnapshot(state =>
      get(state, 'user.userProfile.userPreferences.defaultBookProvider.providerName', null)
    );

    const defaultProviderValue = this.store.selectSnapshot(state =>
      get(state, 'user.userProfile.userPreferences.defaultBookProvider.providerValue', null)
    );

    const bookProviders = this.auctionItem.bookValues.filter(
      bookValue => bookValue.providerName === defaultBookProvider
    );

    if (bookProviders.length > 0) {
      return this.getCurrentValue(bookProviders, defaultBookProvider, defaultProviderValue);
    }

    return undefined;
  }

  getTenantNameFromStore() {
    return this.store.selectSnapshot((state => get (state, 'configuration.configuration.tenantName')));
  }

  getCurrentValue(bookProviders, defaultBookProvider, defaultProviderValue) {
    const filteredProvider = bookProviders[0];
    const providerValue =
      defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.NADA.toLocaleLowerCase() ||
        defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.BLACK_BOOK.toLocaleLowerCase()
        ? `${defaultProviderValue}`.toLocaleLowerCase()
        : null;

    const filteredBookValues = filteredProvider.values.filter(value => value.providerValue.toLocaleLowerCase() === providerValue);

    if (filteredBookValues.length > 0) {
      this.spreadToBook = filteredBookValues[0].spreadToBook;
      return this.spreadToBook;
    }
  }

  get auctionStartTime() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItem.auctionStartTime, true);
  }

  get auctionEndTime() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItem.auctionEndTime, true);
  }

  get auctionExtendedTime() {
    const dateAndTime = this.dateUtilService.localizeDateAndTime(this.auctionItem.auctionExtendEndTime, true);
    return `${dateAndTime} - Extended`;
  }

  redirectToLegacyVDP(){
    window.location.href='/sa-web/faces/pages/search/vehicleDetail.jsp?auctionItemID='+this.auctionItem.legacyAuctionItemId;
  }

  get soldVehicle() {
    return this.auctionItem.auctionItemStatus === 'SOLD';
  }

  get auctionSaleTime() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItem.saleDate, true);
  }

  get isInServiceVehiclesEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }

  formatCurrency(currency) {
    return this.currencyFormatService.formatCurrency(currency, false).replaceAll('-', '');
  }

  localizeDate(date) {
    return this.dateUtilService.localizeDateAndTime(date, true);
  }

  getOfferListTooltipTranslations() {
    this.details$.subscribe(details => {
      if (details) {
        if (this.isInServiceVehiclesEnabled && details?.typeCode === 'ACP') {
          this.currentListType = this.translations.customOffer;
          this.offerListTooltipTitle = this.translations.customOfferTooltipTitle;
        } else {
          this.currentListType = this.translations.sharedList;
          this.offerListTooltipTitle = this.translations.sharedListTooltipTitle;
        }
        this.offerListTooltipBody = this.getShareListVehicles();
      }
    });
  }

  getTranslations(){
    const keyParams = {
      'sellModule.details.auctionDetail.tooltipSpreadToBook': {},
      'offerList.general': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translation =>{
        this.spreadToBookMetaTitle = translation[0].metaTitle;
        this.spreadToBookTitle = translation[0].title;
        this.spreadToBookBody = translation[0].body;
        this.translations.partOf = translation[1].partOf;
        this.translations.sharedList = translation[1].sharedList;
        this.translations.customOffer = translation[1].customOffer;
        this.translations.sharedListTooltipTitle = translation[1].offerListToolTipTitle;
        this.translations.customOfferTooltipTitle = translation[1].customOfferToolTipTitle;
      });
  }
}
